/*
 * Define a form page to indicate if the activity is still occurring.
 */
import css from './pages.module.css'
import { activityStillOccurring } from '../choices'
import { choicePage } from './choicePage'

export const activityStillOccurringPage = propOverrides => {
  const choices = activityStillOccurring()

  const props = {
    pageId: 'activity_still_occurring_page',
    fieldName: 'still_occurring',
    choices: choices,
    label: 'Is the activity still occurring?',
    className: css.choices,
    labelClassName: css.largeLabel,
    ...propOverrides
  }

  return {
    ...choicePage({ ...props }),
    action: {
      type: 'goto',
      pageId: values => {
        return values[props.fieldName] == 'no'
          ? props.gotoPageNo
          : props.gotoPageYes
      }
    }
  }
}
